<template>
  <page-outline :title="$t('suppliers.kyc_form._label') + ' - ' + currentSupplier.SocialReason">
    <!-- <template slot="titleContent">
      <span>{{ $t('suppliers.kyc_form._label') }}</span>
      <span style="margin-left:40px;">
        {{
          $t('common.cmpny') + ' : ' +
          currentSupplier.SocialReason
        }}
      </span>
      <span style="margin-left:40px;">
        {{
          $t('common.rprsnttv') + ' : ' +
          currentSupplier.LegalRepresentativeFirstname +
          ' ' +
          currentSupplier.LegalRepresentativeLastname
        }}
      </span>
    </template> -->
    <template slot="pageContent">
      <!-- <div :key="refreshPageContent"> -->
        <!-- <b-row align-h="center" style="margin-bottom:50px;">
          <b-col sm="3" class="form-group"
            v-for="(step, indexStep) in workflow.steps" :key="indexStep">
            <f7-button class="button-action milkyBlockBlack button-tab"
              :active="indexStep === 0" :tab-link="'#tab' + step.id">
              {{ $t('suppliers.kyc_form.' + step.step_label + '._label') }}
            </f7-button>
          </b-col>
        </b-row>
        <f7-tabs animated>
          <f7-tab v-for="(step, indexStep) in workflow.steps" :key="indexStep"
            :id="'tab' + step.id" :active="indexStep === 0">
            <supplier-kyc-form-step :step="step" :seller="currentSupplier"></supplier-kyc-form-step>
          </f7-tab>
        </f7-tabs> -->
        <div class="specialContainer">
        <b-row class="mb-3">
          <b-col cols="2" class="p-0">
            <back-button></back-button>
          </b-col>
        </b-row>
        <b-row>
          <vue-tabs v-model="tabName"
            active-tab-color="#F9FBFC"
            active-text-color="var(--actionButtonColorBlue)">
            <v-tab v-for="(step, indexStep) in workflow.steps" :key="indexStep"
              :title="step.step_label">
              <div slot="title">
                {{ $t('suppliers.kyc_form.' + step.step_label + '._label') }}&nbsp;&nbsp;
                <i class="fa-solid fa-circle-small" v-if="step.status === 101" :style="'color:' + getStatusColor(step.status)"></i>
                <i class="fa-solid fa-circle-small" v-if="step.status === 102" :style="'color:' + getStatusColor(step.status)"></i>
                <i class="fa-solid fa-circle-small" v-if="step.status === 103" :style="'color:' + getStatusColor(step.status)"></i>
                <i class="fa-solid fa-check" v-else-if="step.status === 104" :style="'color:' + getStatusColor(step.status)"></i>
                <i class="fa-solid fa-xmark" v-else-if="step.status === 105" :style="'color:' + getStatusColor(step.status)"></i>
                <i class="fa-solid fa-xmark" v-else-if="step.status === 106" :style="'color:' + getStatusColor(step.status)"></i>
              </div>
              <supplier-kyc-form-step :step="step" :seller="currentSupplier"
                style="margin-top:30px;">
              </supplier-kyc-form-step>
            </v-tab>
            <v-tab v-if="display" :title="$t('suppliers.infos')">
              <br />
              <b-row>
                <b-col cols="12">
                  <table class="table" v-if="DataList">
                    <thead>
                      <th width="170">{{$t('common.title')}}</th>
                      <th width="130">{{$t('common.date_label')}}</th>
                      <th width="550">{{$t('common.comment_label')}}</th>
                      <th width="150">{{$t('common.actions')}}</th>
                    </thead>
                    <tbody>
                      <tr  v-for="result in DataList">
                      <td>{{ result.title }}</td>
                      <td>{{ result.creation_date }}</td>
                      <td>{{ result.note }}</td>
                      <td class="text-center">
                        <span class="fileClickButton mr-4 cursor"
                          @click="editNote(result.id_kyc_custom_data)">
                          {{ $t('common.edit_label') }}
                        </span>
                        <span class="fileClickButton cursor"
                          @click="deleteNote(result.id_kyc_custom_data)">
                          {{ $t('common.del_label') }}
                        </span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <b-row class="justify-content-center" v-else><strong>{{$t('common.no_comment')}}</strong></b-row>
                  <b-row>
                    <b-col cols="2" offset="10">
                      <b-button variant="primary" size="lg" @click="addNote()">
                        <i class="fa-light fa-plus"></i>
                        <span>{{$t('suppliers.add_note')}}</span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </v-tab>
            <!-- <v-tab v-if="!hasFinalStep" title="..." disabled style="color:grey;">
              <div slot="title">
                ...
              </div>
            </v-tab> -->
          </vue-tabs>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'

import SupplierKYCFormStep from './SupplierKYCFormStep'

import {errorMessageAlert} from '@/helpers/alert'

import {loadPage} from '@/helpers/routing'

import moment from 'moment'

import backButton from '@/components/common/backButton.vue'

// import fakeWorkflow from './data/fakeWorkflow.json'

export default {
  name: 'SupplierKYCForm',
  components: {
    'page-outline': PageOutline,
    'supplier-kyc-form-step': SupplierKYCFormStep,
    'back-button': backButton
  },
  data () {
    return {
      currentSupplier: '',
      hasFinalStep: false,
      refreshPageContent: false,
      tabName: '',
      workflow: {},
      display: false,
      DataList: []
    }
  },
  created () {
    this.currentSupplier = this.$engine.services.suppliers.selectedSupplier
    console.log('cur', this.currentSupplier)

    // this.workflow = fakeWorkflow
    // console.log(this.workflow.steps)

    let that = this
    this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
    this.$engine.services.suppliers.getKYCSteps({
      idSeller: this.currentSupplier.IdSeller
    })
    .then(resp => {
      console.log(resp)
      this.workflow = resp.data
      setTimeout(function () { that.Dom7('.active_tab').click() }, 0)
      this.display = true
      if (this.workflow.steps[this.workflow.steps.length - 1].status !== 101) {
        this.hasFinalStep = true
      }
      // this.refreshPageContent = !this.refreshPageContent
      // this.tabName = this.workflow.steps[0].step_label
      this.$f7.hidePreloader()
    })
    .catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })

    this.$bus.$on('decideStep', function (step) {
      that.decideStep(step)
    })
    this.listNote()
  },
  beforeDestroy () {
    this.$bus.$off('decideStep')
  },
  methods: {
    decideStep (step) {
      step.idStep = step.id
      step.idExchangeGroup = this.currentSupplier.IdGroupDocument
      let status = step.status

      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      this.$engine.services.suppliers.updateKYCSteps(step)
      .then(resp => {
        this.workflow.steps.find(element => element.id === step.id).status = status
        if (resp.data.steps && resp.data.steps.length) {
          for (let stepIndex in resp.data.steps) {
            let newStep = resp.data.steps[stepIndex]
            this.workflow.steps.push(newStep)
            if (stepIndex === 0) {
              this.tabName = newStep.step_label
            }
          }
        } else {
          this.hasFinalStep = true
        }
        setTimeout(function () { that.Dom7('.active_tab').click() }, 0)

        this.refreshPageContent = !this.refreshPageContent
        this.$f7.hidePreloader()
        if (status === '102') {
          that.$f7.modal({
            title: that.$i18n.t('success.kycstep_saved'),
            text: '<i class="fa-light fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getStatusColor (status) {
      switch (status) {
        case 101:
          return 'grey'
        case 102:
          return 'deepskyblue'
        case 103:
          return 'orange'
        case 104:
          return 'green'
        case 105:
          return 'red'
        case 106:
          return 'orangered'
        default:
          return 'grey'
      }
    },
    addNote () {
      let that = this
      loadPage(that, {url: '/addnote/'})
    },
    editNote (id) {
      let that = this
      loadPage(that, {url: '/editnote/' + id})
    },
    deleteNote (id) {
      let that = this
      this.$f7.modal({
        title: this.$t('suppliers.del'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.services.suppliers.deleteCustomData(id)
              .then(resp => {
                that.$f7.alert('', that.$t('suppliers.delete'))
                that.listNote()
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    listNote () {
      let that = this
      that.$engine.services.suppliers.getCustomData(
        this.$engine.services.suppliers.selectedSupplier.Siren
      )
      .then(resp => {
        resp.data.CustomData.forEach(item => {
          item.creation_date = moment(item.creation_date).format('DD/MM/yyyy HH:mm:ss')
        })
        that.makeList(resp.data.CustomData)
      })
      .catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    makeList (tab) {
      this.DataList = tab
    }
  }
}
</script>
<style>
/* Override des classes de vue-tabs */
.vue-tabs .nav-tabs {
  border-bottom: 1px solid grey;
}
.vue-tabs .nav-tabs > li > a {
  border: 1px solid gray;
}
.vue-tabs .nav-tabs > li > a:hover {
  border: 1px solid gray;
}
.tab.disabled {
  border: none;
  color: black;
  opacity: 1;
}

.specialContainer {
  max-width: 1350px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
</style>
